import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { Tooltip } from 'bootstrap'

import { clearState, getCartSummary } from '../../../../app/pages/checkout/checkoutActions';


const HeaderCartMenu = (props) => {

  var navigate = useNavigate();
  const intl = useIntl()

  //inputs from redux
  const {
    cartSummary,
    loading
  } = props;

  //actions
  const {
    clearState,
    getCartSummary
  } = props;

  const [items, setItems] = useState([])

  useEffect(() => {
    getCartSummary();
    return () => {
      clearState()
    }
  }, []);

  useEffect(() => {

    if (cartSummary && cartSummary.items) {
      setItems(cartSummary.items)
    }
  }, [cartSummary])

  useEffect(() => {
    const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    const tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new Tooltip(tooltipTriggerEl)
    })
    return function cleanup() {
      tooltipList.forEach(t => t.dispose())
    };
  }, []);


  return (
    <div onClick={() => navigate("/checkout-management/checkout-summary")} style={{ marginRight: "10px" }}>
      <button
        className="btn  btn-icon position-relative me-5"
        data-bs-toggle="tooltip"
        title={intl.formatMessage({ id: 'HEADER.SHOPPING_CART' })}
      >
        <i className="ki-duotone ki-basket fs-2x"><span className="path1"></span><span className="path2"></span><span className="path3"></span><span className="path4"></span><span className="path5"></span></i>
        <span className="position-absolute top-0 start-100 translate-middle  badge badge-circle badge-primary">{items.length}</span>
      </button>
    </div>
  )
}


const mapStateToProps = state => {
  return {
    cartSummary: state.Checkout.cartSummary,
    success: state.Checkout.success
  };
};

const mapActionsToProps = {
  clearState, getCartSummary
}

export default connect(mapStateToProps, mapActionsToProps)(HeaderCartMenu)
